import React from "react";
import PropTypes from "prop-types";
import { useLocales } from "../../core/i18n";

const BAR = "h-px bg-current transition-all duration-200";

/** The phone-only hamburger that opens and closes the menu overlay (#mobile-menu). */
const MenuButton = ({ open, onToggle }) => {
	const { t } = useLocales();
	return (
		<button
			type="button"
			onClick={onToggle}
			className="lg:hidden p-3 -mr-3 min-h-11 min-w-11 inline-flex items-center justify-center text-pp-ink hover:text-pp-accent transition-colors duration-150"
			aria-label={t("ui.toggleMenu")}
			aria-expanded={open}
			aria-controls="mobile-menu"
		>
			<div className="w-5 h-4 flex flex-col justify-between">
				<span className={`${BAR} ${open ? "rotate-45 translate-y-2" : ""}`}></span>
				<span className={`${BAR} ${open ? "opacity-0" : ""}`}></span>
				<span className={`${BAR} ${open ? "-rotate-45 -translate-y-2" : ""}`}></span>
			</div>
		</button>
	);
};

MenuButton.propTypes = {
	open: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
};

export default MenuButton;
